export default "__VITE_ASSET__CK0RtL8s__"